export default __webpack_public_path__ + "media/images/logo_with_favicon.200-6213b213daca2a4987cc41ef313da796.png";